// extracted by mini-css-extract-plugin
export default {"bioContainer":"Bio_bioContainer__utF5s","bioColContainer":"Bio_bioColContainer__rVbXR","bioCol":"Bio_bioCol__aeZgx","bioParagraph":"Bio_bioParagraph__-2oa7"};